import { lazy } from "react";

export const ErrorBoundary = lazy(() => import("./ErrorBoundary"));
export const Error = lazy(() => import("./Error"));
export const Fallback = lazy(() => import("./Fallback"));
